import { AxiosResponse } from "axios";
import { Http } from "./index";
import { PostData, SubscribeInterface } from "./interface.api";

interface FormParams {
  [k: string]: string | Blob | undefined;
}
interface PreserveParams {
  [k: string]: boolean;
}

type ServerStatus = "success" | "error";
export interface ServerResponse {
  Status: ServerStatus;
  Message?: string;
}
interface OrderRes extends ServerResponse {
  ErrCode?: number;
}

class Api {
  async order(
    data: any,
    recaptcha: string | undefined
  ): Promise<AxiosResponse<OrderRes> | Error> {
    const formData = this.buildFormData({
      ...data,
      "g-recaptcha-response": recaptcha,
    });
    const response = await Http.request({
      method: "POST",
      url: "api/place_order",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }

  async subscribe(data: SubscribeInterface, recaptcha: string) {
    const formData = this.buildFormData({
      email: data.email,
      name: data.name,
      "g-recaptcha-response": recaptcha,
    });
    const response = await Http.request({
      method: "POST",
      url: "api/subscribe",
      data: formData,
    });
    return response.data;
  }

  buildFormData = (
    params: FormParams = {},
    removeEmpty = true,
    preserve: PreserveParams = {}
  ): FormData => {
    const formData = new FormData();
    for (const key of Object.keys(params)) {
      if (!params[key] && removeEmpty && !preserve[key]) {
        continue;
      }
      let val = params[key];
      if (!(val instanceof Blob)) {
        val = "" + val;
      }
      formData.append(key, val);
    }
    return formData;
  };
}
export default new Api();
